__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "airbnb-react-host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "19.2.5", () => (Promise.all([__webpack_require__.e(897), __webpack_require__.e(708)]).then(() => (() => (__webpack_require__(7708))))));
			register("react-router-dom", "7.14.2", () => (Promise.all([__webpack_require__.e(385), __webpack_require__.e(897), __webpack_require__.e(861)]).then(() => (() => (__webpack_require__(6385))))));
			register("react/jsx-runtime", "19.2.5", () => (__webpack_require__.e(627).then(() => (() => (__webpack_require__(1627))))));
			register("react", "19.2.5", () => (__webpack_require__.e(979).then(() => (() => (__webpack_require__(1979))))));
			register("swr", "2.4.1", () => (Promise.all([__webpack_require__.e(182), __webpack_require__.e(897)]).then(() => (() => (__webpack_require__(7182))))));
			initExternal(1426);
			initExternal(1773);
			initExternal(5287);
			initExternal(9478);
			initExternal(17);
			initExternal(7181);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};